import { createContext } from 'react'

const WorkspacePusherContext = createContext({})

export default WorkspacePusherContext
